import { render, staticRenderFns } from "./OtherNicheIcon.vue?vue&type=template&id=39858560&scoped=true"
import script from "./OtherNicheIcon.vue?vue&type=script&lang=js"
export * from "./OtherNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39858560",
  null
  
)

export default component.exports